

























import Vue from 'vue';
import CourseSelectionForm from '@/components/forms/CourseSelectionForm.vue';
import PipelineMenuWrapper from '@/components/PipelineMenuWrapper.vue';
import pipeline from '@/pipeline';
import { Course } from '@/store/modules/course/state';
import Analytics from '@/helpers/analytics';
import { Toast } from '@/components/ds';
import { AnalyticsActions } from '@/store/modules/analytics/actions';

export default Vue.extend({
  components: {
    PipelineMenuWrapper,
    CourseSelectionForm,
    Toast,
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    name(): string {
      return this.$store.getters.userFirstName;
    },
    availableCourses(): string[] {
      return this.$store.getters.availableCourses || [];
    },
    selectedCourse(): string {
      return this.$store.getters.selectedCourse?.id;
    },
  },
  created() {
    this.$store.dispatch('PULL_AVAILABLE_COURSES');
  },
  methods: {
    async selectedHandler(course: Course) {
      await this.$store
        .dispatch('UPDATE_COURSE', { course })
        .catch(error => this.errorHandler(error));

      this.$store.dispatch(AnalyticsActions.COURSE_CHOSEN, {
        grad_curso_escolhido: course.name,
        course: course.name,
      });
      Analytics.trackGTM({
        event: 'course_selected',
        grad_selected_course: course.name,
        processo_seletivo_id: this.$store.getters.admissionId,
      });

      pipeline.next();
    },
    errorHandler(error: any) {
      this.error = true;
      setTimeout(() => {
        this.error = false;
      }, 5000);
      throw error;
    },
  },
});
